import _get from 'lodash/get';
import { Values } from '@lib/interfaces/form';
import { InputTelValue } from '@lib/components/Input/InputTel';

export default function getPhoneNumberPreparedDataFromValues(
  values?: Values,
  name?: string,
) {
  const phoneNumberValue = _get(values, name || 'phoneNumber') as InputTelValue;
  return phoneNumberValue?.countryCode && phoneNumberValue?.number
    ? {
        countryCode: phoneNumberValue.countryCode,
        number: phoneNumberValue.number,
      }
    : null;
}
